// extracted by mini-css-extract-plugin
module.exports = {"specialSubtype":"_2vEVnE2fQmGOabTk5FhaaD"};